export default __webpack_public_path__ + "static/media/CY.59aada2d.svg";